import { useUserCookie } from "@/app/hooks/useUserCookie"
import { ROUTES } from "@/constants/routes"
import { FC } from "react"
import { ButtonProps } from "./types"
import { RecallButton } from "@recall/common"

export const SignUpButton: FC<ButtonProps> = () => {
    const user = useUserCookie()

    const isLoggedIn = Boolean(user?.uid)

    const handleOpenApp = () => {
        window.open(ROUTES.APP, "_blank")
    }

    const buttonText = isLoggedIn ? "Open App" : "Sign up"

    return (
        <RecallButton mode="secondary" size="large" onClick={handleOpenApp} fullWidth>
            {buttonText}
        </RecallButton>
    )
}
